<template>
  <div style="max-width:100%;">
    <!-- MODAL -->
    <div >
     <lefmodal v-if="$store.state.resultadocalculos != []" height="auto" width="1000px" :scrollable="true" :adaptive="true" name="lp-csll">
      <div style="margin: 0;" class="table-responsive">
        <table class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th scope="col" colspan="6" style="text-align:center">CSLL Detalhado</th>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">DESCRIÇÃO</th>
              <th scope="col">PRIMEIRO TRIMESTRE</th>
              <th scope="col">SEGUNDO TRIMESTRE</th>
              <th scope="col">TERCEIRO TRIMESTRE</th>
              <th scope="col">QUARTO TRIMESTRE</th>
              <th style="min-width: 150px;" scope="col">ANUAL</th>
            </tr>
          </thead>
          <tbody>
          
            <tr  v-for="(item,i) in $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.receitas : 0" :key="i" >
              <th scope="row">{{`BASE DE CÁLCULO ${item.csll}% CNAE ${item.cnae}`}}</th>
              <td>{{ item.receitasTrimestrais._primeiroTrimestre }}</td>
              <td>{{ item.receitasTrimestrais._segundoTrimestre }}</td>
              <td>{{ item.receitasTrimestrais._terceiroTrimestre }}</td>
              <td>{{ item.receitasTrimestrais._quartoTrimestre }}</td>
              <td>{{ item.receitasTrimestrais._anual }}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="row">TOTAL BASE DE CÁLCULO I</th>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.baseCalculoI._primeiroTrimestre : ''}}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.baseCalculoI._segundoTrimestre: '' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.baseCalculoI._terceiroTrimestre: '' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.baseCalculoI._quartoTrimestre: '' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.baseCalculoI._anual: '' }}</td>
            </tr>
            <tr>
              <th scope="row">Demais receitas</th>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.demaisReceitas._primeiroTrimestre:'' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.demaisReceitas._segundoTrimestre: '' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.demaisReceitas._terceiroTrimestre: '' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.demaisReceitas._quartoTrimestre: '' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.demaisReceitas._anual:'' }}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="row">TOTAL BASE DE CÁLCULO II</th>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.baseCalculoII._primeiroTrimestre : ''}}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.baseCalculoII._segundoTrimestre : ''}}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.baseCalculoII._terceiroTrimestre: '' }}</td>
              <td>{{$store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ?  $store.state.resultadocalculos.lucroPresumido.csllDetalhado.baseCalculoII._quartoTrimestre : ''}}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.baseCalculoII._anual: '' }}</td>
            </tr>
            <tr>
              <th scope="row">CSLL 9%</th>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.csll9._primeiroTrimestre : '' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ?$store.state.resultadocalculos.lucroPresumido.csllDetalhado.csll9._segundoTrimestre: '' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ?$store.state.resultadocalculos.lucroPresumido.csllDetalhado.csll9._terceiroTrimestre: '' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ?$store.state.resultadocalculos.lucroPresumido.csllDetalhado.csll9._quartoTrimestre: '' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.csll9._anual: '' }}</td>
            </tr>
            <tr>
              <th scope="row">TOTAL CSLL</th>
              <td>{{$store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.total._primeiroTrimestre: '' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.total._segundoTrimestre: '' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.total._terceiroTrimestre: '' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.total._quartoTrimestre: '' }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.csllDetalhado!= null ? $store.state.resultadocalculos.lucroPresumido.csllDetalhado.total._anual: '' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </lefmodal>



    <lefmodal v-if="$store.state.resultadocalculos != []" height="auto" width="1000px" :scrollable="true" :adaptive="true" name="lp-irpj">
      <div style="margin: 0;" class="table-responsive">
     
        <table class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th scope="col" colspan="6" style="text-align:center">IRPJ Detalhado</th>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">DESCRIÇÃO</th>
              <th scope="col">PRIMEIRO TRIMESTRE</th>
              <th scope="col">SEGUNDO TRIMESTRE</th>
              <th scope="col">TERCEIRO TRIMESTRE</th>
              <th scope="col">QUARTO TRIMESTRE</th>
              <th style="min-width: 150px;" scope="col">ANUAL</th>
            </tr>
          </thead>
          <tbody>
          <tr v-if="$store.state.resultadocalculos.lucroPresumido.irpjDetalhado == null">

          </tr>
            <tr v-else v-for="(item,i) in $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.receitas" :key="i" >
              <th scope="row">{{`BASE DE CÁLCULO ${item.irpj}% CNAE ${item.cnae}`}}</th>
              <td>{{ item.receitasTrimestrais._primeiroTrimestre }}</td>
              <td>{{ item.receitasTrimestrais._segundoTrimestre }}</td>
              <td>{{ item.receitasTrimestrais._terceiroTrimestre }}</td>
              <td>{{ item.receitasTrimestrais._quartoTrimestre }}</td>
              <td>{{ item.receitasTrimestrais._anual }}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="row">TOTAL BASE DE CÁLCULO I</th>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' :  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.baseCalculoI._primeiroTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.baseCalculoI._segundoTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.baseCalculoI._terceiroTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.baseCalculoI._quartoTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.baseCalculoI._anual }}</td>
            </tr>
            <tr>
              <th scope="row">Demais receitas</th>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.demaisReceitas._primeiroTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.demaisReceitas._segundoTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.demaisReceitas._terceiroTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.demaisReceitas._quartoTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.demaisReceitas._anual }}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="row">TOTAL BASE DE CÁLCULO II</th>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.baseCalculoII._primeiroTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.baseCalculoII._segundoTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' :  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.baseCalculoII._terceiroTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.baseCalculoII._quartoTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.baseCalculoII._anual }}</td>
            </tr>
            <tr>
              <th scope="row">IRPJ 15%</th>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.irpj15._primeiroTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.irpj15._segundoTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.irpj15._terceiroTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.irpj15._quartoTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.irpj15._anual }}</td>
            </tr>
            <tr>
              <th scope="row">ADICIONAL 10%</th>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.adicional10._primeiroTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.adicional10._segundoTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.adicional10._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' :   $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.adicional10._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' :  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.adicional10._anual }}</td>
            </tr>
            <tr>
              <th scope="row">TOTAL IRPJ</th>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' :  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.total._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' :  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.total._segundoTrimestre }}</td>
              <td>{{  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' : $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.total._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' :  $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.total._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroPresumido.irpjDetalhado ==  null ? '' :   $store.state.resultadocalculos.lucroPresumido.irpjDetalhado.total._anual }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </lefmodal>
    </div>
    
    <!-- 
    <lefmodal v-if="$store.state.resultadocalculos != []" height="auto" width="1000px" :scrollable="true" :adaptive="true" name="lrt-csll">
      <div style="margin: 0;" class="table-responsive">
        <table class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th scope="col" colspan="6" style="text-align:center">CSLL Detalhado</th>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">DESCRIÇÃO</th>
              <th scope="col">PRIMEIRO TRIMESTRE</th>
              <th scope="col">SEGUNDO TRIMESTRE</th>
              <th scope="col">TERCEIRO TRIMESTRE</th>
              <th scope="col">QUARTO TRIMESTRE</th>
              <th style="min-width: 150px;" scope="col">ANUAL</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">RESULTADO CONTÁBIL</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.resultadoContabil._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.resultadoContabil._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.resultadoContabil._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.resultadoContabil._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.resultadoContabil._anual }}</td>
            </tr>
            <tr>
              <th scope="row">ADIÇÕES</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.adicoes._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.adicoes._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.adicoes._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.adicoes._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.adicoes._anual }}</td>
            </tr>
            <tr>
              <th scope="row">EXCLUSÕES</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.exclusoes._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.exclusoes._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.exclusoes._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.exclusoes._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.exclusoes._anual }}</td>
            </tr>
            <tr>
              <th scope="row">LUCRO REAL</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.lucroReal._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.lucroReal._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.lucroReal._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.lucroReal._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.lucroReal._anual }}</td>
            </tr>
            <tr>
              <th scope="row">COMPENSAÇÃO BASE NEGATIVA 30%</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.compensacaoPrejuizo._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.compensacaoPrejuizo._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.compensacaoPrejuizo._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.compensacaoPrejuizo._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.compensacaoPrejuizo._anual }}</td>
            </tr>
            <tr>
              <th scope="row">BASE DE CÁCULO</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.baseCalculo._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.baseCalculo._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.baseCalculo._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.baseCalculo._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.baseCalculo._anual }}</td>
            </tr>
            <tr>
              <th scope="row">CSLL 9%</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.aliquota9._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.aliquota9._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.aliquota9._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.aliquota9._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.aliquota9._anual }}</td>
            </tr>
            <tr>
              <th scope="row">TOTAL DA CSLL DEVIDA</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.total._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.total._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.total._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.total._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.csllDetalhado.total._anual }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </lefmodal>
    <lefmodal v-if="$store.state.resultadocalculos != []" height="auto" width="1000px" :scrollable="true" :adaptive="true" name="lrt-irpj">
      <div style="margin: 0;" class="table-responsive">
        <table class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th scope="col" colspan="6" style="text-align:center">IRPJ Detalhado</th>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">DESCRIÇÃO</th>
              <th scope="col">PRIMEIRO TRIMESTRE</th>
              <th scope="col">SEGUNDO TRIMESTRE</th>
              <th scope="col">TERCEIRO TRIMESTRE</th>
              <th scope="col">QUARTO TRIMESTRE</th>
              <th style="min-width: 150px;" scope="col">ANUAL</th>
            </tr>
          </thead>
          <tbody>
            <tr style="background:#EEEEEE">
              <th scope="row">RESULTADO CONTÁBIL</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.resultadoContabil._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.resultadoContabil._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.resultadoContabil._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.resultadoContabil._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.resultadoContabil._anual }}</td>
            </tr>
            <tr>
              <th scope="row">ADIÇÕES</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.adicoes._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.adicoes._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.adicoes._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.adicoes._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.adicoes._anual }}</td>
            </tr>
            <tr>
              <th scope="row">EXCLUSÕES</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.exclusoes._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.exclusoes._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.exclusoes._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.exclusoes._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.exclusoes._anual }}</td>
            </tr>
            <tr>
              <th scope="row">LUCRO REAL</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.lucroReal._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.lucroReal._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.lucroReal._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.lucroReal._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.lucroReal._anual }}</td>
            </tr>
            <tr>
              <th scope="row">COMPENSAÇÃO BASE NEGATIVA 30%</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.compensacaoPrejuizo._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.compensacaoPrejuizo._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.compensacaoPrejuizo._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.compensacaoPrejuizo._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.compensacaoPrejuizo._anual }}</td>
            </tr>
            <tr>
              <th scope="row">BASE DE CÁCULO</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.baseCalculo._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.baseCalculo._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.baseCalculo._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.baseCalculo._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.baseCalculo._anual }}</td>
            </tr>
            <tr>
              <th scope="row">IRPJ 15%</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.aliquota15._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.aliquota15._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.aliquota15._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.aliquota15._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.aliquota15._anual }}</td>
            </tr>
            <tr>
              <th scope="row">ADICIONAL 10%</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.adicional10._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.adicional10._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.adicional10._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.adicional10._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.adicional10._anual }}</td>
            </tr>
            <tr>
              <th scope="row">TOTAL DA IRPJ DEVIDA</th>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.total._primeiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.total._segundoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.total._terceiroTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.total._quartoTrimestre }}</td>
              <td>{{ $store.state.resultadocalculos.lucroRealTrimestral.irpjDetalhado.total._anual }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </lefmodal>
    <lefmodal v-if="$store.state.resultadocalculos != []" height="auto" width="1250px" :scrollable="true" :adaptive="true" name="lra-csll">
      <div style="margin: 0;" class="table-responsive">
        <table class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th scope="col" colspan="14" style="text-align:center">CSLL Detalhado</th>
            </tr>
            <tr style="background:#EEEEEE">
              <th  scope="col">Desc</th>
              <th  scope="col">Jan</th>
              <th  scope="col">Fev</th>
              <th  scope="col">Mar</th>
              <th  scope="col">Abr</th>
              <th  scope="col">Mai</th>
              <th  scope="col">Jun</th>
              <th  scope="col">Jul</th>
              <th  scope="col">Ago</th>
              <th  scope="col">Set</th>
              <th  scope="col">Out</th>
              <th  scope="col">Nov</th>
              <th scope="col">Dez</th>
              <th  scope="col">Anual</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">RESULTADO CONTÁBIL</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.resultadoContabil[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.resultadoContabil[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.resultadoContabil[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.resultadoContabil[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.resultadoContabil[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.resultadoContabil[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.resultadoContabil[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.resultadoContabil[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.resultadoContabil[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.resultadoContabil[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.resultadoContabil[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.resultadoContabil[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">ADIÇÕES</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.adicoes[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.adicoes[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.adicoes[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.adicoes[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.adicoes[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.adicoes[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.adicoes[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.adicoes[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.adicoes[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.adicoes[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.adicoes[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.adicoes[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">EXCLUSÕES</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.exclusoes[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.exclusoes[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.exclusoes[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.exclusoes[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.exclusoes[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.exclusoes[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.exclusoes[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.exclusoes[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.exclusoes[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.exclusoes[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.exclusoes[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.exclusoes[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">LUCRO REAL</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.lucroReal[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.lucroReal[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.lucroReal[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.lucroReal[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.lucroReal[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.lucroReal[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.lucroReal[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.lucroReal[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.lucroReal[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.lucroReal[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.lucroReal[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.lucroReal[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">BASE DE CÁCULO</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.baseCalculo[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.baseCalculo[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.baseCalculo[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.baseCalculo[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.baseCalculo[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.baseCalculo[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.baseCalculo[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.baseCalculo[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.baseCalculo[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.baseCalculo[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.baseCalculo[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.baseCalculo[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">CSLL 9%</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.aliquota9[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.aliquota9[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.aliquota9[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.aliquota9[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.aliquota9[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.aliquota9[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.aliquota9[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.aliquota9[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.aliquota9[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.aliquota9[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.aliquota9[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.aliquota9[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">VALOR DEVIDO MÊS</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.valorDevidoMes[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.valorDevidoMes[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.valorDevidoMes[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.valorDevidoMes[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.valorDevidoMes[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.valorDevidoMes[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.valorDevidoMes[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.valorDevidoMes[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.valorDevidoMes[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.valorDevidoMes[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.valorDevidoMes[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.valorDevidoMes[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">TOTAL DA CSLL DEVIDA</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.total[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.total[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.total[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.total[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.total[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.total[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.total[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.total[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.total[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.total[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.total[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.csllDetalhado.total[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </lefmodal>
        <lefmodal v-if="$store.state.resultadocalculos != []" height="auto" width="1250px" :scrollable="true" :adaptive="true" name="lra-irpj">
      <div style="margin: 0;" class="table-responsive">
        <table class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th scope="col" colspan="14" style="text-align:center">IRPJ Detalhado</th>
            </tr>
            <tr style="background:#EEEEEE">
              <th  scope="col">Desc</th>
              <th  scope="col">Jan</th>
              <th  scope="col">Fev</th>
              <th  scope="col">Mar</th>
              <th  scope="col">Abr</th>
              <th  scope="col">Mai</th>
              <th  scope="col">Jun</th>
              <th  scope="col">Jul</th>
              <th  scope="col">Ago</th>
              <th  scope="col">Set</th>
              <th  scope="col">Out</th>
              <th  scope="col">Nov</th>
              <th scope="col">Dez</th>
              <th  scope="col">Anual</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">RESULTADO CONTÁBIL</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.resultadoContabil[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.resultadoContabil[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.resultadoContabil[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.resultadoContabil[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.resultadoContabil[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.resultadoContabil[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.resultadoContabil[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.resultadoContabil[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.resultadoContabil[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.resultadoContabil[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.resultadoContabil[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.resultadoContabil[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">ADIÇÕES</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.adicoes[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.adicoes[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.adicoes[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.adicoes[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.adicoes[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.adicoes[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.adicoes[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.adicoes[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.adicoes[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.adicoes[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.adicoes[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.adicoes[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">EXCLUSÕES</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.exclusoes[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.exclusoes[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.exclusoes[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.exclusoes[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.exclusoes[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.exclusoes[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.exclusoes[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.exclusoes[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.exclusoes[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.exclusoes[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.exclusoes[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.exclusoes[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">LUCRO REAL</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.lucroReal[9]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.lucroReal[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.lucroReal[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.lucroReal[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.lucroReal[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.lucroReal[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.lucroReal[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.lucroReal[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.lucroReal[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.lucroReal[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.lucroReal[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.lucroReal[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">BASE DE CÁCULO</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.baseCalculo[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.baseCalculo[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.baseCalculo[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.baseCalculo[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.baseCalculo[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.baseCalculo[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.baseCalculo[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.baseCalculo[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.baseCalculo[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.baseCalculo[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.baseCalculo[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.baseCalculo[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">IRPJ 15%</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota15[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota15[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota15[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota15[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota15[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota15[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota15[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota15[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota15[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota15[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota15[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota15[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">ADICIONAL 10%</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota10[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota10[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota10[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota10[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota10[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota10[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota10[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota10[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota10[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota10[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota10[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.aliquota10[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">VALOR DEVIDO MÊS</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.valorDevidoMes[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.valorDevidoMes[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.valorDevidoMes[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.valorDevidoMes[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.valorDevidoMes[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.valorDevidoMes[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.valorDevidoMes[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.valorDevidoMes[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.valorDevidoMes[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.valorDevidoMes[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.valorDevidoMes[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.valorDevidoMes[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
            <tr>
              <th scope="row">TOTAL DA IRPJ DEVIDA</th>
              <td data-label="Jan" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.total[0]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.total[1]._valor}}</td>
              <td data-label="Mar" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.total[2]._valor}}</td>
              <td data-label="Abr" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.total[3]._valor}}</td>
              <td data-label="Mai" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.total[4]._valor}}</td>
              <td data-label="Jun" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.total[5]._valor}}</td>
              <td data-label="Jul" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.total[6]._valor}}</td>
              <td data-label="Ago" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.total[7]._valor}}</td>
              <td data-label="Set" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.total[8]._valor}}</td>
              <td data-label="Out" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.total[9]._valor}}</td>
              <td data-label="Nov" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.total[10]._valor}}</td>
              <td data-label="Fev" scope="col">{{$store.state.resultadocalculos.lucroRealAnual.irpjDetalhado.total[11]._valor}}</td>
              <td data-label="Total" scope="col"><strong>0</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </lefmodal> -->
    <div v-if="spinner == true">
      <b-spinner style="position:relative; top: 100px"></b-spinner>
    </div>
    <div v-if="spinner == false" style="margin: 10px 25px;" class="conteiner">
      <div class="nav-bar">
        <p v-if="$store.state.step == 1">
          Home /
          <strong style="color:#AF3437">Simulação</strong>
        </p>
        <p
          v-if="$store.state.step == 2 || $store.state.step == 3 || $store.state.step == 4 || $store.state.step >= 5"
        >
          Home / Simulação /
          Regime
          / <strong style="color:#AF3437">Resultados</strong>
        </p>
      </div>

      <!-- OBSERVACOES -->

      <div style="margin-right:25px" v-if="$store.state.totalresultstep == 2">
      
      <p v-if="$store.state.resultstep == 1" style="margin-left:15px; font-size:13px; color:#383838; margin-top:25px; font-weight:700" >Simples Nacional</p>

      <p v-if="$store.state.resultstep == 1" style="margin-left:15px; font-size:13px; color:#383838; margin-top:10px; font-weight:500" align="justify" v-html="obs[0].informacao"></p>

      <p v-if="$store.state.resultstep == 2" style="margin-left:15px; font-size:13px; color:#383838; margin-top:25px; font-weight:700" >Lucro Presumido</p>

      <p v-if="$store.state.resultstep == 2" style="margin-left:15px; font-size:13px; color:#383838; margin-top:10px; font-weight:500" align="justify" v-html="obs[1].informacao"></p>

      <p v-if="$store.state.resultstep == 3" style="margin-left:15px; font-size:13px; color:#383838; margin-top:25px; font-weight:700" >Lucro Real (Trimestral)</p>

      <p v-if="$store.state.resultstep == 3" style="margin-left:15px; font-size:13px; color:#383838; margin-top:10px; font-weight:500" align="justify" v-html="obs[2].informacao"></p>

      <p v-if="$store.state.resultstep == 4" style="margin-left:15px; font-size:13px; color:#383838; margin-top:25px; font-weight:700" >Lucro Real (Anual)</p>

      <p v-if="$store.state.resultstep == 4" style="margin-left:15px; font-size:13px; color:#383838; margin-top:10px; font-weight:500" align="justify" v-html="obs[3].informacao"></p>

      </div>

      <!-- TITULOS -->

      <p style="margin-left:15px; font-size:16px; color:#383838; margin-top:40px; font-weight:700" v-if="$store.state.totalresultstep == 1">Resultado comparativo</p>
      
      <!-- <p style="margin-left:15px; font-size:16px; color:#383838; margin-top:40px; font-weight:700" v-if="$store.state.totalresultstep == 2 && $store.state.resultstep == 1">Simples Nacional</p>
      
      <p style="margin-left:15px; font-size:16px; color:#383838; margin-top:40px; font-weight:700" v-if="$store.state.totalresultstep == 2 && $store.state.resultstep == 2">Lucro Presumido</p>

      <p style="margin-left:15px; font-size:16px; color:#383838; margin-top:40px; font-weight:700" v-if="$store.state.totalresultstep == 2 && $store.state.resultstep == 3">Lucro Real (Trimestral)</p>
    
      <p style="margin-left:15px; font-size:16px; color:#383838; margin-top:40px; font-weight:700" v-if="$store.state.totalresultstep == 2 && $store.state.resultstep == 4">Lucro Real (Anual)</p> -->

        <!-- SIMPLES ANEXO -->

      <div v-if="$store.state.totalresultstep == 2 && $store.state.resultstep == 1 && $store.state.resultadocalculos.simplesNacional.listaSimplesNacional && $store.state.resultadocalculos.simplesNacional.optante != false">
      <div style="width:97%; margin: 40px 15px; border-bottom: .6px solid rgb(0,0,0,0.10); justify-content:flex-start" class="flex-centered">
          <td  @click="$store.state.simplesstep = item.anexo" v-for="(item,i) in filterAnexo" :key="i" style="text-align:center;width:120px;font-weight:600;font-size:16px;margin-right:20px; cursor:pointer;" :class="{'active-month':$store.state.simplesstep == item.anexo}">{{item._anexo}}</td>
          <td @click="$store.state.simplesstep = 'total'" style="text-align:center;width:100px;font-weight:600;font-size:16px;margin-right:20px;cursor:pointer;" :class="{'active-month':$store.state.simplesstep == 'total'}">Total</td>
      </div>
      </div>
      <div v-if="$store.state.totalresultstep == 2 && $store.state.resultstep == 1 && !$store.state.resultadocalculos.simplesNacional.listaSimplesNacional && $store.state.resultadocalculos.simplesNacional.optante != false">
      <div style="width:97%; margin: 40px 15px; border-bottom: .6px solid rgb(0,0,0,0.10); justify-content:flex-start" class="flex-centered">
          <td @click="$store.state.simplesstep = 'total'" style="text-align:center;width:100px;font-weight:600;font-size:16px;margin-right:20px;cursor:pointer;" :class="{'active-month':$store.state.simplesstep == 'total'}">Total</td>
      </div>
      </div>
      
      <div v-if="$store.state.totalresultstep == 2" style="width:100%; justify-content:flex-start; flex-direction:column" class="flex-centered">
      <div style="align-self: flex-end;">
        <button class="imprimir-btn" style="margin-left:15px;" @click="print()">Imprimir</button>
      </div>
    
    </div>

      <!-- TRIMESTRE SELECIONADOR -->
      <div> 
      <div v-if="$store.state.totalresultstep == 2">  
      <div style="margin-left:15px; justify-content:flex-start; align-items:flex-start" class="flex-centered" v-if="$store.state.resultstep == 4">
        <p style="font-size: 15px; margin-right:20px">Trimestre:</p>
        <p style="font-size: 15px">1º</p>
        <b-form-radio v-model="trimestre" name :value="1" class="large-bar-radio"></b-form-radio>
        <p style="font-size: 15px">2º</p>
        <b-form-radio v-model="trimestre" name :value="2" class="large-bar-radio"></b-form-radio>
        <p style="font-size: 15px">3º</p>
        <b-form-radio v-model="trimestre" name :value="3" class="large-bar-radio"></b-form-radio>
        <p style="font-size: 15px">4º</p>
        <b-form-radio v-model="trimestre" name :value="4" class="large-bar-radio"></b-form-radio>
      </div>
      <div style="margin-left:15px; justify-content:flex-start; align-items:flex-start" class="flex-centered" v-if="$store.state.resultstep == 1 && $store.state.resultadocalculos.simplesNacional.optante != false">
        <p style="font-size: 15px; margin-right:20px">Trimestre:</p>
        <p style="font-size: 15px">1º</p>
        <b-form-radio v-model="trimestre" name :value="1" class="large-bar-radio"></b-form-radio>
        <p style="font-size: 15px">2º</p>
        <b-form-radio v-model="trimestre" name :value="2" class="large-bar-radio"></b-form-radio>
        <p style="font-size: 15px">3º</p>
        <b-form-radio v-model="trimestre" name :value="3" class="large-bar-radio"></b-form-radio>
        <p style="font-size: 15px">4º</p>
        <b-form-radio v-model="trimestre" name :value="4" class="large-bar-radio"></b-form-radio>
      </div>
      </div>
      </div>

    <div style="background:#EEEEEE; padding:20px; border:2px solid #707070" v-if="$store.state.resultadocalculos.simplesNacional.optante == false && $store.state.totalresultstep == 2 && $store.state.resultstep == 1">
      <p style="font-size:13px; color:#383838; margin-top:10px; font-weight:500" align="justify" v-html="$store.state.resultadocalculos.simplesNacional.notaOptante"></p>
    </div>

    <!-- RESULTADO COMPLETO -->

    <div v-if="$store.state.totalresultstep == 3" style="width:100%; justify-content:flex-start; flex-direction:column" class="flex-centered">
      <p style="justify-self:flex-start; margin-left:15px; font-size:20px; color:#383838; margin-top:40px; font-weight:700">Resultado Completo</p>
      <div style="align-self: flex-end;">
        <button class="imprimir-btn" style="margin-left:15px;" @click="$store.state.totalresultstep = 1">Voltar</button>
        <button class="imprimir-btn" style="margin-left:15px;" @click="print()">Imprimir</button>
      </div>
    
    </div>
      
    <!-- SIMPLES COMPLETO -->

      <div
        v-if="$store.state.totalresultstep == 3" 
        class="table-responsive"
      >
        
        <p style="margin-left:15px; font-size:16px; color:#383838; margin-top:40px; font-weight:700">Simples Nacional</p>
        <table style="margin-bottom: 20px; width:100%" class="table">
          <thead>

            <tr style="background:#EEEEEE">
              <th scope="col">TRIBUTOS</th>
              <th  scope="col">JANEIRO</th>
              <th  scope="col">FEVEREIRO</th>
              <th  scope="col">MARÇO</th>
              <th scope="col">TOTAL TRIMESTRAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th  scope="col">IRPJ</th>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[0]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[1]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[2]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpjTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">CSLL</th>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[0]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[1]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[2]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csllTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">PIS</th>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[0]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[1]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[2]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pisTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">COFINS</th>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[0]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[1]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[2]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofinsTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">ICMS</th>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[0]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[1]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[2]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icmsTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">IPI</th>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[0]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[1]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[2]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipiTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">ISS</th>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[0]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[1]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[2]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.issTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">CPP</th>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[0]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[1]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[2]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cppTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">TOTAL</th>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[0]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[1]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[2]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._primeiroTrimestre}}</td>
            </tr>
          </tbody>
        </table>


        <table style="margin-bottom: 20px;width:100%" class="table">
          <thead>

            <tr style="background:#EEEEEE">
              <th scope="col">TRIBUTOS</th>
              <th   scope="col">ABRIL</th>
              <th   scope="col">MAIO</th>
              <th   scope="col">JUNHO</th>
              <th scope="col">TOTAL TRIMESTRAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th  scope="col">IRPJ</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpjTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">CSLL</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csllTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">PIS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pisTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">COFINS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofinsTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">ICMS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icmsTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">IPI</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipiTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">ISS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.issTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">CPP</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cppTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th  scope="col">TOTAL</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._segundoTrimestre}}</td>
            </tr>
          </tbody>
        </table>

        <table style="margin-bottom: 20px;width:100%" class="table">
          <thead>

            <tr style="background:#EEEEEE">
              <th scope="col">TRIBUTOS</th>
              <th   scope="col">JULHO</th>
              <th   scope="col">AGOSTO</th>
              <th   scope="col">SETEMBRO</th>
              <th scope="col">TOTAL TRIMESTRAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th  scope="col">IRPJ</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpjTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">CSLL</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csllTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">PIS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pisTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">COFINS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofinsTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">ICMS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icmsTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">IPI</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipiTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">ISS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.issTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">CPP</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cppTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th  scope="col">TOTAL</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._terceiroTrimestre}}</td>
            </tr>
          </tbody>
        </table>

        <table style="margin-bottom: 20px;width:100%" class="table">
          <thead>

            <tr style="background:#EEEEEE">
              <th scope="col">TRIBUTOS</th>
              <th   scope="col">OUTUBRO</th>
              <th   scope="col">NOVEMBRO</th>
              <th   scope="col">DEZEMBRO</th>
              <th scope="col">TOTAL TRIMESTRAL</th>
              <th scope="col">TOTAL ANUAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th  scope="col">IRPJ</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[9]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[10]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[11]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpjTrimestral._quartoTrimestre}}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpjTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">CSLL</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[9]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[10]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[11]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csllTrimestral._quartoTrimestre}}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csllTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">PIS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[9]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[10]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[11]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pisTrimestral._quartoTrimestre}}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pisTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">COFINS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[9]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[10]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[11]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofinsTrimestral._quartoTrimestre}}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofinsTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">ICMS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[9]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[10]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[11]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icmsTrimestral._quartoTrimestre}}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icmsTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">IPI</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[9]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[10]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[11]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipiTrimestral._quartoTrimestre}}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipiTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">ISS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[9]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[10]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[11]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.issTrimestral._quartoTrimestre}}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.issTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">CPP</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[9]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[10]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[11]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cppTrimestral._quartoTrimestre}}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cppTrimestral._anual}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th  scope="col">TOTAL</th>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[9]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[10]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[11]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._quartoTrimestre}}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._anual}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- TERMINA SIMPLES COMPLETO -->

      <!-- SIMPLES ANEXOS COMPLETO -->

    <div
        v-if="$store.state.totalresultstep == 3 && $store.state.resultadocalculos.simplesNacional.optante == true && filterCompleto != 'nones'"
        class="table-responsive"
      >
      <div v-for="(item,i) in filterCompleto" :key="i">
      <div v-if="item.mostrarTabela == true">
        <table style="margin-bottom:20px; width:100%" class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th colspan="5" scope="col">{{item.cnae}} - {{item.denominacao}} - {{item._anexo}} - 1º TRIMESTRE </th>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">TRIBUTOS</th>
              <th scope="col">JANEIRO</th>
              <th scope="col">FEVEREIRO</th>
              <th scope="col">MARÇO</th>
              <th scope="col">TOTAL TRIMESTRAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th scope="col">IRPJ</th>
              <td scope="col">{{ item.resultados.irpj[0]._valor }}</td>
              <td scope="col">{{ item.resultados.irpj[1]._valor }}</td>
              <td scope="col">{{ item.resultados.irpj[2]._valor }}</td>
              <td scope="col">{{ item.resultados.irpjTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">CSLL</th>
              <td scope="col">{{ item.resultados.csll[0]._valor }}</td>
              <td scope="col">{{ item.resultados.csll[1]._valor }}</td>
              <td scope="col">{{ item.resultados.csll[2]._valor }}</td>
              <td scope="col">{{ item.resultados.csllTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">PIS</th>
              <td scope="col">{{ item.resultados.pis[0]._valor }}</td>
              <td scope="col">{{ item.resultados.pis[1]._valor }}</td>
              <td scope="col">{{ item.resultados.pis[2]._valor }}</td>
              <td scope="col">{{ item.resultados.pisTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">COFINS</th>
              <td scope="col">{{ item.resultados.cofins[0]._valor }}</td>
              <td scope="col">{{ item.resultados.cofins[1]._valor }}</td>
              <td scope="col">{{ item.resultados.cofins[2]._valor }}</td>
              <td scope="col">{{ item.resultados.cofinsTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">ICMS</th>
              <td scope="col">{{ item.resultados.icms[0]._valor }}</td>
              <td scope="col">{{ item.resultados.icms[1]._valor }}</td>
              <td scope="col">{{ item.resultados.icms[2]._valor }}</td>
              <td scope="col">{{ item.resultados.icmsTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">IPI</th>
              <td scope="col">{{ item.resultados.ipi[0]._valor }}</td>
              <td scope="col">{{ item.resultados.ipi[1]._valor }}</td>
              <td scope="col">{{ item.resultados.ipi[2]._valor }}</td>
              <td scope="col">{{ item.resultados.ipiTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">ISS</th>
              <td scope="col">{{ item.resultados.iss[0]._valor }}</td>
              <td scope="col">{{ item.resultados.iss[1]._valor }}</td>
              <td scope="col">{{ item.resultados.iss[2]._valor }}</td>
              <td scope="col">{{ item.resultados.issTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">CPP</th>
              <td scope="col">{{ item.resultados.cpp[0]._valor }}</td>
              <td scope="col">{{ item.resultados.cpp[1]._valor }}</td>
              <td scope="col">{{ item.resultados.cpp[2]._valor }}</td>
              <td scope="col">{{ item.resultados.cppTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">TOTAL</th>
              <td scope="col">{{ item.resultados.total[0]._valor }}</td>
              <td scope="col">{{ item.resultados.total[1]._valor }}</td>
              <td scope="col">{{ item.resultados.total[2]._valor }}</td>
              <td scope="col">{{ item.resultados.totalTrimestral._primeiroTrimestre}}</td>
            </tr>
          </tbody>
        </table>

        <table style="margin-bottom:20px; width:100%" class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th colspan="5" scope="col">{{item.cnae}} - {{item.denominacao}} - {{item._anexo}} - 2º TRIMESTRE </th>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">TRIBUTOS</th>
              <th scope="col">ABRIL</th>
              <th scope="col">MAIO</th>
              <th scope="col">JUNHO</th>
              <th scope="col">TOTAL TRIMESTRAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th scope="col">IRPJ</th>
              <td scope="col">{{ item.resultados.irpj[3]._valor }}</td>
              <td scope="col">{{ item.resultados.irpj[4]._valor }}</td>
              <td scope="col">{{ item.resultados.irpj[5]._valor }}</td>
              <td scope="col">{{ item.resultados.irpjTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">CSLL</th>
              <td scope="col">{{ item.resultados.csll[3]._valor }}</td>
              <td scope="col">{{ item.resultados.csll[4]._valor }}</td>
              <td scope="col">{{ item.resultados.csll[5]._valor }}</td>
              <td scope="col">{{ item.resultados.csllTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">PIS</th>
              <td scope="col">{{ item.resultados.pis[3]._valor }}</td>
              <td scope="col">{{ item.resultados.pis[4]._valor }}</td>
              <td scope="col">{{ item.resultados.pis[5]._valor }}</td>
              <td scope="col">{{ item.resultados.pisTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">COFINS</th>
              <td scope="col">{{ item.resultados.cofins[3]._valor }}</td>
              <td scope="col">{{ item.resultados.cofins[4]._valor }}</td>
              <td scope="col">{{ item.resultados.cofins[5]._valor }}</td>
              <td scope="col">{{ item.resultados.cofinsTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">ICMS</th>
              <td scope="col">{{ item.resultados.icms[3]._valor }}</td>
              <td scope="col">{{ item.resultados.icms[4]._valor }}</td>
              <td scope="col">{{ item.resultados.icms[5]._valor }}</td>
              <td scope="col">{{ item.resultados.icmsTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">IPI</th>
              <td scope="col">{{ item.resultados.ipi[3]._valor }}</td>
              <td scope="col">{{ item.resultados.ipi[4]._valor }}</td>
              <td scope="col">{{ item.resultados.ipi[5]._valor }}</td>
              <td scope="col">{{ item.resultados.ipiTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">ISS</th>
              <td scope="col">{{ item.resultados.iss[3]._valor }}</td>
              <td scope="col">{{ item.resultados.iss[4]._valor }}</td>
              <td scope="col">{{ item.resultados.iss[5]._valor }}</td>
              <td scope="col">{{ item.resultados.issTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">CPP</th>
              <td scope="col">{{ item.resultados.cpp[3]._valor }}</td>
              <td scope="col">{{ item.resultados.cpp[4]._valor }}</td>
              <td scope="col">{{ item.resultados.cpp[5]._valor }}</td>
              <td scope="col">{{ item.resultados.cppTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">TOTAL</th>
              <td scope="col">{{ item.resultados.total[3]._valor }}</td>
              <td scope="col">{{ item.resultados.total[4]._valor }}</td>
              <td scope="col">{{ item.resultados.total[5]._valor }}</td>
              <td scope="col">{{ item.resultados.totalTrimestral._segundoTrimestre}}</td>
            </tr>
          </tbody>
        </table>

        <table style="margin-bottom:20px; width:100%" class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th colspan="5" scope="col">{{item.cnae}} - {{item.denominacao}} - {{item._anexo}} - 3º TRIMESTRE </th>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">TRIBUTOS</th>
              <th scope="col">JULHO</th>
              <th scope="col">AGOSTO</th>
              <th scope="col">SETEMBRO</th>
              <th scope="col">TOTAL TRIMESTRAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th scope="col">IRPJ</th>
              <td scope="col">{{ item.resultados.irpj[6]._valor }}</td>
              <td scope="col">{{ item.resultados.irpj[7]._valor }}</td>
              <td scope="col">{{ item.resultados.irpj[8]._valor }}</td>
              <td scope="col">{{ item.resultados.irpjTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">CSLL</th>
              <td scope="col">{{ item.resultados.csll[6]._valor }}</td>
              <td scope="col">{{ item.resultados.csll[7]._valor }}</td>
              <td scope="col">{{ item.resultados.csll[8]._valor }}</td>
              <td scope="col">{{ item.resultados.csllTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">PIS</th>
              <td scope="col">{{ item.resultados.pis[6]._valor }}</td>
              <td scope="col">{{ item.resultados.pis[7]._valor }}</td>
              <td scope="col">{{ item.resultados.pis[8]._valor }}</td>
              <td scope="col">{{ item.resultados.pisTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">COFINS</th>
              <td scope="col">{{ item.resultados.cofins[6]._valor }}</td>
              <td scope="col">{{ item.resultados.cofins[7]._valor }}</td>
              <td scope="col">{{ item.resultados.cofins[8]._valor }}</td>
              <td scope="col">{{ item.resultados.cofinsTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">ICMS</th>
              <td scope="col">{{ item.resultados.icms[6]._valor }}</td>
              <td scope="col">{{ item.resultados.icms[7]._valor }}</td>
              <td scope="col">{{ item.resultados.icms[8]._valor }}</td>
              <td scope="col">{{ item.resultados.icmsTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">IPI</th>
              <td scope="col">{{ item.resultados.ipi[6]._valor }}</td>
              <td scope="col">{{ item.resultados.ipi[7]._valor }}</td>
              <td scope="col">{{ item.resultados.ipi[8]._valor }}</td>
              <td scope="col">{{ item.resultados.ipiTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">ISS</th>
              <td scope="col">{{ item.resultados.iss[6]._valor }}</td>
              <td scope="col">{{ item.resultados.iss[7]._valor }}</td>
              <td scope="col">{{ item.resultados.iss[8]._valor }}</td>
              <td scope="col">{{ item.resultados.issTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th scope="col">CPP</th>
              <td scope="col">{{ item.resultados.cpp[6]._valor }}</td>
              <td scope="col">{{ item.resultados.cpp[7]._valor }}</td>
              <td scope="col">{{ item.resultados.cpp[8]._valor }}</td>
              <td scope="col">{{ item.resultados.cppTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">TOTAL</th>
              <td scope="col">{{ item.resultados.total[6]._valor }}</td>
              <td scope="col">{{ item.resultados.total[7]._valor }}</td>
              <td scope="col">{{ item.resultados.total[8]._valor }}</td>
              <td scope="col">{{ item.resultados.totalTrimestral._terceiroTrimestre}}</td>
            </tr>
          </tbody>
        </table>

        <table style="margin-bottom:20px; width:100%" class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th colspan="6" scope="col">{{item.cnae}} - {{item.denominacao}} - {{item._anexo}} - 4º TRIMESTRE </th>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">TRIBUTOS</th>
              <th scope="col">OUTUBRO</th>
              <th scope="col">NOVEMBRO</th>
              <th scope="col">DEZEMBRO</th>
              <th scope="col">TOTAL TRIMESTRAL</th>
              <th scope="col">ANUAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th scope="col">IRPJ</th>
              <td scope="col">{{ item.resultados.irpj[9]._valor }}</td>
              <td scope="col">{{ item.resultados.irpj[10]._valor }}</td>
              <td scope="col">{{ item.resultados.irpj[11]._valor }}</td>
              <td scope="col">{{ item.resultados.irpjTrimestral._quartoTrimestre}}</td>
              <td scope="col">{{ item.resultados.totalTrimestral._anual}}</td>
            </tr>
            <tr>
              <th scope="col">CSLL</th>
              <td scope="col">{{ item.resultados.csll[9]._valor }}</td>
              <td scope="col">{{ item.resultados.csll[10]._valor }}</td>
              <td scope="col">{{ item.resultados.csll[11]._valor }}</td>
              <td scope="col">{{ item.resultados.irpjTrimestral._quartoTrimestre}}</td>
              <td scope="col">{{ item.resultados.totalTrimestral._anual}}</td>
            </tr>
            <tr>
              <th scope="col">PIS</th>
              <td scope="col">{{ item.resultados.pis[9]._valor }}</td>
              <td scope="col">{{ item.resultados.pis[10]._valor }}</td>
              <td scope="col">{{ item.resultados.pis[11]._valor }}</td>
              <td scope="col">{{ item.resultados.irpjTrimestral._quartoTrimestre}}</td>
              <td scope="col">{{ item.resultados.totalTrimestral._anual}}</td>
            </tr>
            <tr>
              <th scope="col">COFINS</th>
              <td scope="col">{{ item.resultados.cofins[9]._valor }}</td>
              <td scope="col">{{ item.resultados.cofins[10]._valor }}</td>
              <td scope="col">{{ item.resultados.cofins[11]._valor }}</td>
              <td scope="col">{{ item.resultados.irpjTrimestral._quartoTrimestre}}</td>
              <td scope="col">{{ item.resultados.totalTrimestral._anual}}</td>
            </tr>
            <tr>
              <th scope="col">ICMS</th>
              <td scope="col">{{ item.resultados.icms[9]._valor }}</td>
              <td scope="col">{{ item.resultados.icms[10]._valor }}</td>
              <td scope="col">{{ item.resultados.icms[11]._valor }}</td>
              <td scope="col">{{ item.resultados.irpjTrimestral._quartoTrimestre}}</td>
              <td scope="col">{{ item.resultados.totalTrimestral._anual}}</td>
            </tr>
            <tr>
              <th scope="col">IPI</th>
              <td scope="col">{{ item.resultados.ipi[9]._valor }}</td>
              <td scope="col">{{ item.resultados.ipi[10]._valor }}</td>
              <td scope="col">{{ item.resultados.ipi[11]._valor }}</td>
              <td scope="col">{{ item.resultados.irpjTrimestral._quartoTrimestre}}</td>
              <td scope="col">{{ item.resultados.totalTrimestral._anual}}</td>
            </tr>
            <tr>
              <th scope="col">ISS</th>
              <td scope="col">{{ item.resultados.iss[9]._valor }}</td>
              <td scope="col">{{ item.resultados.iss[10]._valor }}</td>
              <td scope="col">{{ item.resultados.iss[11]._valor }}</td>
              <td scope="col">{{ item.resultados.irpjTrimestral._quartoTrimestre}}</td>
              <td scope="col">{{ item.resultados.totalTrimestral._anual}}</td>
            </tr>
            <tr>
              <th scope="col">CPP</th>
              <td scope="col">{{ item.resultados.cpp[9]._valor }}</td>
              <td scope="col">{{ item.resultados.cpp[10]._valor }}</td>
              <td scope="col">{{ item.resultados.cpp[11]._valor }}</td>
              <td scope="col">{{ item.resultados.irpjTrimestral._quartoTrimestre}}</td>
              <td scope="col">{{ item.resultados.totalTrimestral._anual}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">TOTAL</th>
              <td scope="col">{{ item.resultados.total[9]._valor }}</td>
              <td scope="col">{{ item.resultados.total[10]._valor }}</td>
              <td scope="col">{{ item.resultados.total[11]._valor }}</td>
              <td scope="col">{{ item.resultados.irpjTrimestral._quartoTrimestre}}</td>
              <td scope="col">{{ item.resultados.totalTrimestral._anual}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
          <div style="background:#EEEEEE; padding:20px; border:2px solid #707070">
            <p style="font-size:13px; color:#383838; margin-top:10px; font-weight:500" align="justify" v-html="item.notaExplicativa.notaFormatada"></p>
          </div>
        </div>
      </div>
    </div>
    <div  v-if="$store.state.totalresultstep == 3 && $store.state.resultadocalculos.simplesNacional.optante == false" style="background:#EEEEEE; padding:20px; border:2px solid #707070">
      <p style="font-size:13px; color:#383838; margin-top:10px; font-weight:500" align="justify" v-html="$store.state.resultadocalculos.simplesNacional.notaOptante"></p>
    </div>

      <!-- TERMINA SIMPLES ANEXOS COMPLETO -->

      <!-- TABELA PRESUMIDO COMPLETO -->


     <div
        v-if="$store.state.totalresultstep == 3" 
        class="table-responsive"
      >
    <p style="margin-left:15px; font-size:16px; color:#383838; margin-top:40px; font-weight:700">Lucro Presumido</p>
    <table style="width:100%" class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th  scope="col">TRIBUTOS</th>
              <th scope="col">PRIMEIRO TRIMESTRE</th>
              <th scope="col">SEGUNDO TRIMESTRE</th>
              <th scope="col">TERCEIRO TRIMESTRE</th>
              <th scope="col">QUARTO TRIMESTRE</th>
              <th scope="col">ANUAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th style="cursor:pointer" @click="openTable('lp-irpj')" scope="col">IRPJ</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.irpj._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.irpj._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.irpj._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.irpj._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.irpj._anual }}</td>
            </tr>
            <tr>
              <th style="cursor:pointer" @click="openTable('lp-csll')" scope="col">CSLL</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.csll._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.csll._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.csll._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.csll._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.csll._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">PIS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.pis._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.pis._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.pis._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.pis._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.pis._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">COFINS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.cofins._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.cofins._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.cofins._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.cofins._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.cofins._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">ICMS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.icms._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.icms._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.icms._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.icms._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.icms._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">IPI</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.ipi._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.ipi._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.ipi._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.ipi._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.ipi._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">ISS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.iss._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.iss._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.iss._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.iss._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.iss._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">PREV. SOCIAL</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.previdenciaSocial._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.previdenciaSocial._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.previdenciaSocial._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.previdenciaSocial._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.previdenciaSocial._anual }}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th  scope="col">TOTAL</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.total._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.total._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.total._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.total._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.total._anual }}</td>
            </tr>
          </tbody>
      </table>
     </div>

      <!-- TERMINA TABELA PRESUMIDO COMPLETO --> 

      <!-- TABELA REAL TRIMESTRAL COMPLETO -->

       <div
        v-if="$store.state.totalresultstep == 3" 
        class="table-responsive"
      >
      <p style="margin-left:15px; font-size:16px; color:#383838; margin-top:40px; font-weight:700">Lucro Real Trimestral</p>
      <table style="width:100%" class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th  scope="col">TRIBUTOS</th>
              <th scope="col">PRIMEIRO TRIMESTRE</th>
              <th scope="col">SEGUNDO TRIMESTRE</th>
              <th scope="col">TERCEIRO TRIMESTRE</th>
              <th scope="col">QUARTO TRIMESTRE</th>
              <th scope="col">ANUAL</th>
            </tr>
          </thead>
          <tbody>

           <tr>
              <th  scope="col">IRPJ</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.irpj._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.irpj._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.irpj._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.irpj._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.irpj._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">CSLL</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.csll._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.csll._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.csll._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.csll._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.csll._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">PIS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.pis._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.pis._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.pis._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.pis._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.pis._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">COFINS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.cofins._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.cofins._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.cofins._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.cofins._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.cofins._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">ICMS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.icms._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.icms._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.icms._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.icms._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.icms._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">ISS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.iss._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.iss._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.iss._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.iss._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.iss._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">IPI</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.ipi._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.ipi._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.ipi._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.ipi._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.ipi._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">PREV. SOCIAL</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.previdenciaSocial._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.previdenciaSocial._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.previdenciaSocial._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.previdenciaSocial._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.previdenciaSocial._anual }}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th  scope="col">TOTAL</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._anual }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- TERMINA TABELA REAL TRIMESTRAL COMPLETO -->

      <!-- TABELA REAL ANUAL COMPLETO -->

             <div
        v-if="$store.state.totalresultstep == 3" 
        class="table-responsive"
      >
      <p style="margin-left:15px; font-size:16px; color:#383838; margin-top:40px; font-weight:700">Lucro Real Anual</p>
        <table style="margin-bottom: 20px;width:100%" class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th  scope="col">TRIBUTOS</th>
              <th   scope="col">JANEIRO</th>
              <th   scope="col">FEVEREIRO</th>
              <th   scope="col">MARÇO</th>             
              <th scope="col">TOTAL TRIMESTRAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th  scope="col">IRPJ</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[0]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[1]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[2]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpjTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">CSLL</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[0]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[1]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[2]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csllTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">PIS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[0]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[1]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[2]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pisTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">COFINS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[0]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[1]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[2]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofinsTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">ICMS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[0]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[1]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[2]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icmsTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">ISS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[0]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[1]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[2]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.issTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">IPI</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[0]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[1]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[2]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipiTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">PREV. SOCIAL</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[0]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[1]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[2]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocialTrimestral._primeiroTrimestre}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">TOTAL</th>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[0]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[1]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[2]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._primeiroTrimestre}}</td>
            </tr>
          </tbody>
        </table>

         <table style="margin-bottom: 20px;width:100%" class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th scope="col">TRIBUTOS</th>          
              <th scope="col">ABRIL</th>
              <th scope="col">MAIO</th>
              <th scope="col">JUNHO</th>
              <th scope="col">TOTAL TRIMESTRAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th  scope="col">IRPJ</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpjTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">CSLL</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csllTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">PIS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pisTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">COFINS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofinsTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">ICMS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icmsTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">ISS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.issTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">IPI</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipiTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">PREV. SOCIAL</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[3]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[4]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[5]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocialTrimestral._segundoTrimestre}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">TOTAL</th>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[3]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[4]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[5]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._segundoTrimestre}}</td>
            </tr>
          </tbody>
        </table>

         <table style="margin-bottom: 20px;width:100%" class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th  scope="col">TRIBUTOS</th>         
              <th scope="col">JULHO</th>
              <th scope="col">AGOSTO</th>
              <th scope="col">SETEMBRO</th>
              <th scope="col">TOTAL TRIMESTRAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th  scope="col">IRPJ</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpjTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">CSLL</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csllTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">PIS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pisTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">COFINS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofinsTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">ICMS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icmsTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">ISS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.issTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">IPI</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipiTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr>
              <th  scope="col">PREV. SOCIAL</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[6]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[7]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[8]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocialTrimestral._terceiroTrimestre}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">TOTAL</th>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[6]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[7]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[8]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._terceiroTrimestre}}</td>
            </tr>
          </tbody>
        </table>

         <table style="margin-bottom: 20px;width:100%" class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th scope="col">TRIBUTOS</th>
              <th scope="col">OUTUBRO</th>
              <th scope="col">NOVEMBRO</th>
              <th scope="col">DEZEMBRO</th>
              <th scope="col">TOTAL TRIMESTRAL</th>
              <th scope="col">ANUAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th  scope="col">IRPJ</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[9]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[10]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[11]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpjTrimestral._quartoTrimestre}}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpjTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">CSLL</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[9]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[10]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[11]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csllTrimestral._quartoTrimestre}}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csllTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">PIS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[9]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[10]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[11]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pisTrimestral._quartoTrimestre}}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pisTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">COFINS</th>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[9]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[10]._valor }}</td>
              <td   scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[11]._valor }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofinsTrimestral._quartoTrimestre}}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofinsTrimestral._anual}}</td>
            </tr>
            <tr>
              <th scope="col">ICMS</th>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[9]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[10]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[11]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icmsTrimestral._quartoTrimestre}}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icmsTrimestral._anual}}</td>
            </tr>
            <tr>
              <th scope="col">ISS</th>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[9]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[10]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[11]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.issTrimestral._quartoTrimestre}}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.issTrimestral._anual}}</td>
            </tr>
            <tr>
              <th scope="col">IPI</th>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[9]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[10]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[11]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipiTrimestral._quartoTrimestre}}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipiTrimestral._anual}}</td>
            </tr>
            <tr>
              <th scope="col">PREV. SOCIAL</th>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[9]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[10]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[11]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocialTrimestral._quartoTrimestre}}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocialTrimestral._anual}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">TOTAL</th>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[9]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[10]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[11]._valor }}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._quartoTrimestre}}</td>
              <td scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._anual}}</td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- TERMINA TABELA REAL TRIMESTRAL COMPLETO -->

      <!-- TERMINA COMPLETO -->

      <!-- TABELA SIMPLES -->

      <div
        v-if="$store.state.totalresultstep == 2 && $store.state.resultstep == 1 && $store.state.simplesstep == 'total' && $store.state.resultadocalculos.simplesNacional.optante != false"
        class="table-responsive"
      >

        <table style="width:100%" class="table">
          <thead>

            <tr style="background:#EEEEEE">
              <th scope="col">TRIBUTOS</th>
              <th v-if="trimestre == 1"  scope="col">JANEIRO</th>
              <th v-if="trimestre == 1"  scope="col">FEVEREIRO</th>
              <th v-if="trimestre == 1"  scope="col">MARÇO</th>
              <th v-if="trimestre == 2"  scope="col">ABRIL</th>
              <th v-if="trimestre == 2"  scope="col">MAIO</th>
              <th v-if="trimestre == 2"  scope="col">JUNHO</th>
              <th v-if="trimestre == 3"  scope="col">JULHO</th>
              <th v-if="trimestre == 3"  scope="col">AGOSTO</th>
              <th v-if="trimestre == 3"  scope="col">SETEMBRO</th>
              <th v-if="trimestre == 4"  scope="col">OUTUBRO</th>
              <th v-if="trimestre == 4"  scope="col">NOVEMBRO</th>
              <th v-if="trimestre == 4"  scope="col">DEZEMBRO</th>
              <th scope="col">TOTAL TRIMESTRAL</th>
              <th v-if="trimestre == 4"  scope="col">ANUAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th  scope="col">IRPJ</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpj[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpjTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpjTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpjTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpjTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.irpjTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">CSLL</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csll[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csllTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csllTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csllTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csllTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.csllTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">PIS</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pis[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pisTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pisTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pisTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pisTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.pisTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">COFINS</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofins[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofinsTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofinsTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofinsTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofinsTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cofinsTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">ICMS</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icms[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icmsTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icmsTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icmsTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icmsTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.icmsTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">IPI</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipi[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipiTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipiTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipiTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipiTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.ipiTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">ISS</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.iss[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.issTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.issTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.issTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.issTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.issTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">CPP</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cpp[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cppTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cppTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cppTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cppTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.cppTrimestral._anual}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th  scope="col">TOTAL</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.total[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._anual}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- TERMINA TABELA SIMPLES -->

      <!-- TABELA SIMPLES ANEXO -->

       <div
        v-if="$store.state.totalresultstep == 2 && $store.state.resultstep == 1 && $store.state.simplesstep != 'total' && $store.state.resultadocalculos.simplesNacional.optante != false"
        class="table-responsive"
      >

        <div v-for="(item,i) in filter" :key="i">
        <div v-if="item.mostrarTabela == true">
        <table style="width:100%" class="table">
          <thead>
            <tr style="background:#EEEEEE;">  
              <th v-if="trimestre != 4" colspan="5">
                {{item.cnae}} - {{item.denominacao}} - {{item._anexo}}
              </th>
              <th v-if="trimestre == 4" colspan="6">
                {{item.cnae}} - {{item.denominacao}} - {{item._anexo}}
              </th>
            </tr>
            <tr style="background:#EEEEEE">
              <th scope="col">TRIBUTOS</th>
              <th v-if="trimestre == 1"  scope="col">JANEIRO</th>
              <th v-if="trimestre == 1"  scope="col">FEVEREIRO</th>
              <th v-if="trimestre == 1"  scope="col">MARÇO</th>
              <th v-if="trimestre == 2"  scope="col">ABRIL</th>
              <th v-if="trimestre == 2"  scope="col">MAIO</th>
              <th v-if="trimestre == 2"  scope="col">JUNHO</th>
              <th v-if="trimestre == 3"  scope="col">JULHO</th>
              <th v-if="trimestre == 3"  scope="col">AGOSTO</th>
              <th v-if="trimestre == 3"  scope="col">SETEMBRO</th>
              <th v-if="trimestre == 4"  scope="col">OUTUBRO</th>
              <th v-if="trimestre == 4"  scope="col">NOVEMBRO</th>
              <th v-if="trimestre == 4"  scope="col">DEZEMBRO</th>
              <th scope="col">TOTAL TRIMESTRAL</th>
              <th v-if="trimestre == 4"  scope="col">ANUAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th  scope="col">IRPJ</th>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.irpj[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.irpj[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.irpj[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.irpj[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.irpj[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.irpj[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.irpj[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.irpj[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.irpj[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.irpj[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.irpj[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.irpj[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ item.resultados.irpjTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ item.resultados.irpjTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ item.resultados.irpjTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.irpjTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.irpjTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">CSLL</th>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.csll[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.csll[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.csll[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.csll[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.csll[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.csll[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.csll[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.csll[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.csll[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.csll[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.csll[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.csll[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ item.resultados.csllTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ item.resultados.csllTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ item.resultados.csllTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.csllTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.csllTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">PIS</th>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.pis[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.pis[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.pis[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.pis[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.pis[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.pis[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.pis[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.pis[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.pis[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.pis[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.pis[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.pis[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ item.resultados.pisTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ item.resultados.pisTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ item.resultados.pisTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.pisTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.pisTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">COFINS</th>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.cofins[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.cofins[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.cofins[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.cofins[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.cofins[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.cofins[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.cofins[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.cofins[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.cofins[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.cofins[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.cofins[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.cofins[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ item.resultados.cofinsTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ item.resultados.cofinsTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ item.resultados.cofinsTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.cofinsTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.cofinsTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">ICMS</th>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.icms[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.icms[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.icms[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.icms[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.icms[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.icms[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.icms[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.icms[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.icms[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.icms[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.icms[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.icms[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ item.resultados.icmsTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ item.resultados.icmsTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ item.resultados.icmsTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.icmsTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.icmsTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">IPI</th>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.ipi[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.ipi[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.ipi[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.ipi[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.ipi[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.ipi[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.ipi[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.ipi[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.ipi[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.ipi[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.ipi[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.ipi[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ item.resultados.ipiTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ item.resultados.ipiTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ item.resultados.ipiTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.ipiTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.ipiTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">ISS</th>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.iss[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.iss[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.iss[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.iss[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.iss[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.iss[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.iss[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.iss[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.iss[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.iss[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.iss[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.iss[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ item.resultados.issTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ item.resultados.issTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ item.resultados.issTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.issTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.issTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">CPP</th>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.cpp[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.cpp[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.cpp[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.cpp[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.cpp[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.cpp[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.cpp[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.cpp[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.cpp[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.cpp[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.cpp[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.cpp[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ item.resultados.cppTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ item.resultados.cppTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ item.resultados.cppTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.cppTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.cppTrimestral._anual}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th  scope="col">TOTAL</th>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.total[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.total[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ item.resultados.total[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.total[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.total[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ item.resultados.total[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.total[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.total[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ item.resultados.total[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.total[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.total[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ item.resultados.total[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ item.resultados.totalTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ item.resultados.totalTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ item.resultados.totalTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.totalTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ item.resultados.totalTrimestral._anual}}</td>
            </tr>
          </tbody>
        </table>
        </div>
        <div v-else>
          <div style="background:#EEEEEE; padding:20px; border:2px solid #707070">
            <p style="font-size:13px; color:#383838; margin-top:10px; font-weight:500" align="justify" v-html="item.notaExplicativa.notaFormatada"></p>
          </div>
        </div>
        </div>
      </div>

      <!-- TERMINA TABELA SIMPLES ANEXO -->

      <!-- TABELA PRESUMIDO -->

       <div
        v-if="$store.state.totalresultstep == 2 && $store.state.resultstep == 2"
        class="table-responsive"
      >
        <table style="width:100%" class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th  scope="col">TRIBUTOS</th>
              <th scope="col">PRIMEIRO TRIMESTRE</th>
              <th scope="col">SEGUNDO TRIMESTRE</th>
              <th scope="col">TERCEIRO TRIMESTRE</th>
              <th scope="col">QUARTO TRIMESTRE</th>
              <th scope="col">ANUAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th style="cursor:pointer" @click="openTable('lp-irpj')" scope="col">IRPJ</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.irpj._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.irpj._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.irpj._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.irpj._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.irpj._anual }}</td>
            </tr>
            <tr>
              <th style="cursor:pointer" @click="openTable('lp-csll')" scope="col">CSLL</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.csll._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.csll._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.csll._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.csll._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.csll._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">PIS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.pis._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.pis._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.pis._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.pis._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.pis._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">COFINS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.cofins._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.cofins._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.cofins._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.cofins._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.cofins._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">ICMS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.icms._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.icms._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.icms._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.icms._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.icms._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">IPI</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.ipi._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.ipi._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.ipi._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.ipi._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.ipi._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">ISS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.iss._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.iss._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.iss._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.iss._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.iss._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">PREV. SOCIAL</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.previdenciaSocial._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.previdenciaSocial._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.previdenciaSocial._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.previdenciaSocial._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.previdenciaSocial._anual }}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th  scope="col">TOTAL</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.total._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.total._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.total._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.total._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroPresumido.total._anual }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- TERMINA TABELA PRESUMIDO -->

      <!-- TABELA REAL TRIMESTRAL -->

       <div
        v-if="$store.state.totalresultstep == 2 && $store.state.resultstep == 3"
        class="table-responsive"
      >
        <table style="width:100%" class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th  scope="col">TRIBUTOS</th>
              <th scope="col">PRIMEIRO TRIMESTRE</th>
              <th scope="col">SEGUNDO TRIMESTRE</th>
              <th scope="col">TERCEIRO TRIMESTRE</th>
              <th scope="col">QUARTO TRIMESTRE</th>
              <th scope="col">ANUAL</th>
            </tr>
          </thead>
          <tbody>

           <tr>
              <th  scope="col">IRPJ</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.irpj._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.irpj._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.irpj._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.irpj._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.irpj._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">CSLL</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.csll._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.csll._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.csll._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.csll._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.csll._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">PIS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.pis._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.pis._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.pis._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.pis._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.pis._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">COFINS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.cofins._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.cofins._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.cofins._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.cofins._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.cofins._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">ICMS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.icms._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.icms._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.icms._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.icms._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.icms._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">ISS</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.iss._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.iss._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.iss._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.iss._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.iss._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">IPI</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.ipi._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.ipi._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.ipi._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.ipi._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.ipi._anual }}</td>
            </tr>
            <tr>
              <th  scope="col">PREV. SOCIAL</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.previdenciaSocial._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.previdenciaSocial._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.previdenciaSocial._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.previdenciaSocial._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.previdenciaSocial._anual }}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th  scope="col">TOTAL</th>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._primeiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._segundoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._terceiroTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._quartoTrimestre }}</td>
              <td  scope="col">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._anual }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- TERMINA TABELA REAL TRIMESTRAL -->

      <!-- LUCRO REAL ANUAL -->

       <div
        v-if="$store.state.totalresultstep == 2 && $store.state.resultstep == 4"
        class="table-responsive"
      >
        <table style="width:100%" class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th  scope="col">TRIBUTOS</th>
              <th v-if="trimestre == 1"  scope="col">JANEIRO</th>
              <th v-if="trimestre == 1"  scope="col">FEVEREIRO</th>
              <th v-if="trimestre == 1"  scope="col">MARÇO</th>
              <th v-if="trimestre == 2"  scope="col">ABRIL</th>
              <th v-if="trimestre == 2"  scope="col">MAIO</th>
              <th v-if="trimestre == 2"  scope="col">JUNHO</th>
              <th v-if="trimestre == 3"  scope="col">JULHO</th>
              <th v-if="trimestre == 3"  scope="col">AGOSTO</th>
              <th v-if="trimestre == 3"  scope="col">SETEMBRO</th>
              <th v-if="trimestre == 4"  scope="col">OUTUBRO</th>
              <th v-if="trimestre == 4"  scope="col">NOVEMBRO</th>
              <th v-if="trimestre == 4"  scope="col">DEZEMBRO</th>
              <th scope="col">TOTAL TRIMESTRAL</th>
              <th v-if="trimestre == 4"  scope="col">ANUAL</th>
            </tr>
          </thead>
          <tbody>
           <tr>
              <th  scope="col">IRPJ</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpj[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpjTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpjTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpjTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpjTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.irpjTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">CSLL</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csll[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csllTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csllTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csllTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csllTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.csllTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">PIS</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pis[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pisTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pisTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pisTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pisTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.pisTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">COFINS</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofins[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofinsTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofinsTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofinsTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofinsTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.cofinsTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">ICMS</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icms[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icmsTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icmsTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icmsTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icmsTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.icmsTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">ISS</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.iss[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.issTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.issTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.issTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.issTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.issTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">IPI</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipi[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipiTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipiTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipiTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipiTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.ipiTrimestral._anual}}</td>
            </tr>
            <tr>
              <th  scope="col">PREV. SOCIAL</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocial[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocialTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocialTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocialTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocialTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.previdenciaSocialTrimestral._anual}}</td>
            </tr>
            <tr style="background:#EEEEEE">
              <th  scope="col">TOTAL</th>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[0]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[1]._valor }}</td>
              <td v-if="trimestre == 1"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[2]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[3]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[4]._valor }}</td>
              <td v-if="trimestre == 2"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[5]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[6]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[7]._valor }}</td>
              <td v-if="trimestre == 3"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[8]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[9]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[10]._valor }}</td>
              <td v-if="trimestre == 4"  scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.total[11]._valor }}</td>
              <td v-if="trimestre == 1" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._primeiroTrimestre}}</td>
              <td v-if="trimestre == 2" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._segundoTrimestre}}</td>
              <td v-if="trimestre == 3" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._terceiroTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._quartoTrimestre}}</td>
              <td v-if="trimestre == 4" scope="col">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._anual}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- TERMINA LUCRO REAL ANUAL -->

      <!-- COMPARATIVO -->

      <div style="margin-right:25px" v-if="$store.state.totalresultstep == 1">

      <!-- <div style="width:97%; margin: 20px 15px; border-bottom: .6px solid rgb(0,0,0,0.10); justify-content:flex-start" class="flex-centered">
        <td style="cursor:pointer;" class='active-month'>Comparativo</td>
      </div> -->
        
      <div v-if="$store.state.totalresultstep == 1">
        <div
        class="table-responsive"
      >

        <table style="margin-bottom: 20px;" class="table">
          <thead>
            <tr style="background:#EEEEEE">
              <th scope="col">REGIME TRIBUTÁRIO</th>
              <th scope="col">PRIMEIRO TRIMESTRE</th>
              <th scope="col">SEGUNDO TRIMESTRE</th>
              <th scope="col">TERCEIRO TRIMESTRE</th>
              <th scope="col">QUARTO TRIMESTRE</th>
              <th style="min-width:150px;" scope="col">ANUAL</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th @click="openResult(1)" style="cursor:pointer;" scope="row">SIMPLES NACIONAL</th>
              <td data-label="Primeiro Trimestre">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._primeiroTrimestre }}</td>
              <td data-label="Segundo Trimestre">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._segundoTrimestre }}</td>
              <td data-label="Terceiro Trimestre">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._terceiroTrimestre }}</td>
              <td data-label="Quarto Trimestre">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._quartoTrimestre }}</td>
              <td data-label="Total">{{ $store.state.resultadocalculos.simplesNacional.total.totalTrimestral._anual }}</td>
            </tr>
            <tr>
              <th @click="openResult(2)" style="cursor:pointer;" scope="row">LUCRO PRESUMIDO</th>
              <td data-label="Primeiro Trimestre">{{ $store.state.resultadocalculos.lucroPresumido.total._primeiroTrimestre }}</td>
              <td data-label="Segundo Trimestre">{{ $store.state.resultadocalculos.lucroPresumido.total._segundoTrimestre }}</td>
              <td data-label="Terceiro Trimestre">{{ $store.state.resultadocalculos.lucroPresumido.total._terceiroTrimestre }}</td>
              <td data-label="Quarto Trimestre">{{ $store.state.resultadocalculos.lucroPresumido.total._quartoTrimestre }}</td>
              <td data-label="Total">{{ $store.state.resultadocalculos.lucroPresumido.total._anual }}</td>
            </tr>
            <tr>
              <th @click="openResult(3)" style="cursor:pointer;" scope="row">LUCRO REAL (TRIMESTRAL)</th>
              <td data-label="Primeiro Trimestre">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._primeiroTrimestre }}</td>
              <td data-label="Segundo Trimestre">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._segundoTrimestre }}</td>
              <td data-label="Terceiro Trimestre">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._terceiroTrimestre }}</td>
              <td data-label="Quarto Trimestre">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._quartoTrimestre }}</td>
              <td data-label="Total">{{ $store.state.resultadocalculos.lucroRealTrimestral.total._anual }}</td>
            </tr>
            <tr>
              <th @click="openResult(4)" style="cursor:pointer;" scope="row">LUCRO REAL (ANUAL)</th>
              <td data-label="Primeiro Trimestre">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._primeiroTrimestre }}</td>
              <td data-label="Segundo Trimestre">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._segundoTrimestre }}</td>
              <td data-label="Terceiro Trimestre">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._terceiroTrimestre }}</td>
              <td data-label="Quarto Trimestre">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._quartoTrimestre }}</td>
              <td data-label="Total">{{ $store.state.resultadocalculos.lucroRealAnual.totalTrimestral._anual }}</td>
            </tr>
          </tbody>
        </table>
        <p align="justify" style="color:#AF3437; font-weight: 700; padding-bottom:50px; margin: 0 25px;">O resultados estão sendo apresentados por trimestre, para facilitar o comparativo. Clique nos regimes para acessar os cálculos individualizados por regime e por tributo.</p>
        <p @click="$store.state.totalresultstep = 3" align="justify" style="cursor:pointer; color:#AF3437; font-weight: 700; padding-bottom:50px; margin: 0 25px;">Clique aqui se quiser imprimir ou ver todos resultados juntos.</p>
      </div>
      
      <!-- TERMINA COMPARATIVO -->

      </div>
      </div>
    </div>

    <div v-if="$store.state.totalresultstep == 2 || $store.state.totalresultstep == 3" class="buttons flex-centered">
      <button @click="$store.state.totalresultstep = 1" class="voltar-btn">Voltar</button>
    </div>
  </div>
</template>

<script>
import lefinput from "../Lefinput";
import { Money } from "v-money";
import api from "../../services/api";
import EventBus from "../../event-bus";
export default {
  components: { Money, lefinput },
  data() {
    return {
      trimestre: 1,
      spinner: false,
      realstep: 1,
      resultado: [],
      obs: [],
      irpj: [],
      csll: [],
    };
  },
  computed: {
    filter(){
      if(this.$store.state.resultadocalculos.simplesNacional.listaSimplesNacional == null){
        return 'nones'  
      }else{
        return this.$store.state.resultadocalculos.simplesNacional.listaSimplesNacional.filter(item => (item.anexo === this.$store.state.simplesstep)) 
      }
    },
      filterCompleto(){
      if(this.$store.state.resultadocalculos.simplesNacional.listaSimplesNacional == null){
        return 'nones'  
      }else{
        return this.$store.state.resultadocalculos.simplesNacional.listaSimplesNacional
      }
    },
    filterAnexo(){
      let arrFilter = this.$store.state.resultadocalculos.simplesNacional.listaSimplesNacional.sort((a, b) => a.anexo - b.anexo)
      return arrFilter.filter((v,i,a)=>a.findIndex(t=>(t.anexo === v.anexo))===i)
    }
  },
  async created() {
    this.spinner = true;
    
    this.obs = await api.infoBuscar("resultado_obs");
    let objetoMeses = this.$store.state.meses;
    let objetoCnae = this.$store.state.envioCalculo[0];
    let selecestado = this.$store.state.envioCalculo[1];
    let irpj = this.$store.state.ecfIrpj;
    let csll = this.$store.state.ecfCsll;
    let previdencia = this.$store.state.ecfPrevidencia;
    let ipi = this.$store.state.ecfIpi;
    let ecf = this.$store.state.importouEcf;
    let idCliente = this.$store.state.idcliente == '' ? 0 : this.$store.state.idcliente;
    let tipoEcf = "";
    if(this.$store.state.presumido == true){
      if(this.$store.state.trimestral == true){
        tipoEcf = "lucroPresumido"
      }else{
        tipoEcf = "lucroPresumido"
      }
    }else{
      if(this.$store.state.trimestral == true){
        tipoEcf = "lucroRealTrimestral"
      }else{
        tipoEcf = "lucroRealAnual"
      }
    }
    console.log(tipoEcf)
    console.log(idCliente)
    console.log(objetoCnae)
    console.log(selecestado)
    this.$store.state.resultadocalculos = await api.calcular(objetoCnae, objetoMeses, selecestado, idCliente, irpj, csll, previdencia, ipi, ecf, tipoEcf)
    console.log(this.$store.state.envioCalculo[0],this.$store.state.envioCalculo[1])
    this.spinner = false;
  },
  methods: {
    print(){
      window.print();
    },
    openResult(n){
      this.$store.state.resultstep = n;
      this.$store.state.totalresultstep = 2;
      window.scrollTo(0,0);
      this.trimestre = 1;
    },
    openTable(table) {
      this.$modal.show(table);
    },
    avancarResult(){
      if(this.totalresultstep == 3){

      }else{
        this.totalresultstep++;
      }
    },
    voltarResult(){
      if(this.totalresultstep == 1){

      }else{
        this.totalresultstep--;
      }
    },
    avancar() {
      this.totalresultstep += 1
      this.$store.state.resultstep += 1
      // if (this.resultstep == 3) {
      //   this.totalresultstep += 1;
      //   this.$store.state.resultstep += 1
      //   this.resultstep = 1;
      // }else {
      //   if(this.resultstep == 1 && this.totalresultstep == 3){
      //     if(this.realstep==1){
      //       this.realstep += 1;  
      //     }else{
      //       this.resultstep += 1;  
      //     }
      //   }else{
      //     this.resultstep += 1;   
      //   }
      // }
      window.scrollTo(0,300);
    },
    voltar() {
      this.totalresultstep -= 1
      this.$store.state.resultstep -= 1
      // if (this.resultstep <= 1) {
      //   if(this.totalresultstep != 1){
      //     if(this.totalresultstep == 3){
      //       if(this.realstep == 2){
      //         this.realstep -= 1;  
      //         return;
      //       }else{
      //     this.totalresultstep -= 1;
      //     this.$store.state.resultstep -= 1
      //     this.resultstep = 3;
      //       }
      //     }else{
      //     this.totalresultstep -= 1;
      //     this.$store.state.resultstep -= 1
      //     this.resultstep = 3;
      //     }
      //   }
      // } else {
      //   this.resultstep -= 1;
      // }
    },
  },
};
</script>

<style>

.table .tributo {
  width: 105px !important;
}

.table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
  margin-bottom: 40px;
}

.table caption {
  font-size: 1.5em;
  margin: .5em 0 .75em;
}

.table tr {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: .35em;
}

.table th,
.table td {
  font-size: 13px;
  border: 1px solid #ddd;
  text-align: center;
}

.table td {
    padding: 0 !important;
}

.table th {
  padding: 2em 0 !important;
  font-size: 13px;
  letter-spacing: .05em;
  text-transform: uppercase;
}

@media screen and (max-width: 900px) {
  .table {
    border: 0;
  }

  .table caption {
    font-size: 1.3em;
  }
  
  .table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  
  .table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: .625em;
  }
  
  .table td {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: 1em;
    text-align: right;
  }
  
  .table td::before {
    /*
    * aria-label has no advantage, it won't be read inside a table
    content: attr(aria-label);
    */
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
  }
  
  .table td:last-child {
    border-bottom: 0;
  }
}
.tr-active{
  background:#FFE6E6;
}
.nav-bar {
  margin: 20px auto;
  background: #eeeeee;
  width: 100%;
  height: 30px;
}

.nav-bar p {
  margin: 10px 0 0 10px !important;
  padding: 3px 0 0 10px;
}

.large-bar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 70px;
  background: #eeeeee;
  max-width: 600px;
  border-radius: 5px;
  padding: 25px;
}

.large-bar::before {
  position: relative;
  content: "";
  background: #af3437;
  height: 70px;
  left: -25px;
  width: 7px;
  border-radius: 5px 0 0 5px;
}

.large-bar-radio {
  margin: 0 30px 0 20px;
}

.large-bar p {
  padding: 15px 0 0 0;
}

/* .large-bar p:before {
  font-family: "Font Awesome 5 Free";
  content: "\f111";
  display: inline-block;
  vertical-align: middle;
  font-weight: 900;
  color: #af3437;
  padding-right: 30px;
} */

select {
  position: relative;
  outline: none;
  padding-left: 10px;
  max-width: 200px;
  height: 38px;
  background: 0% 0% no-repeat padding-box padding-box rgb(255, 255, 255);
  border: 1px solid rgb(187, 187, 187);
  border-radius: 5px;
  cursor: pointer;
}

.input-primary {
  max-width: 533px !important;
  height: 35px !important;
  padding-right: 50px;
  margin-right: -36px;
  padding-top: 10px;
}

.table-cnae {
  width: 100%;
}

.table-cnae tr {
  width: 100%;
}

.table-cnae th {
  width: 100%;
}

.table-cnae td {
  width: 50%;
  text-align: left;
}

.table-meses tr {
  width: 100%;
}

#menu ul li {
  display: inline;
}

.black-bar {
  width: 100%;
  border-bottom: 0.6px solid #555;
}

.month-bar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #eeeeee;
  min-height: 60px;
  margin-top: 15px;
  width: 100%;
}

.replicar {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.buttons {
  display: block;
}

.replicar-btn {
  margin-top: 25px;
  margin-left: 25px;
  width: 140px;
  height: 35px;
  color: #fff;
  background: #af3437;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  font-style: italic;
}

.adicionar-btn {
  margin-left: 10px;
  width: 140px;
  height: 20px;
  color: #fff;
  background: #af3437;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 600;
  font-style: italic;
}

.continuar-btn {
  margin-top: 25px !important;
  width: 140px;
  height: 48px;
  margin: 10px;
  color: #fff;
  background: #af3437;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  font-style: italic;
  margin-bottom: 20px;
}

.voltar-btn {
  margin-top: 25px !important;
  width: 140px;
  height: 48px;
  margin: 10px;
  color: #383838;
  border-radius: 5px;
  font-size: 20px;
  font-weight: 600;
  font-style: italic;
  margin-bottom: 20px;
}

.active-month {
  border-bottom: #af3437 solid 4px;
}

.imprimir-btn {
  margin-top: 25px;
  margin-left: 25px;
  width: 140px;
  height: 35px;
  color: #fff;
  background: #af3437;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  font-style: italic;
}
</style>